import { useEffect } from 'react';
import { usePipelinePageContext } from 'app/pipeline-details/PipelinePageContextProvider';

export default function useHandlePipelineIntegrationsUpdate({ onPipelineIntegrationChange }) {
  const {
    pipeline: { pipelineIntegrations },
  } = usePipelinePageContext();

  useEffect(() => {
    onPipelineIntegrationChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pipelineIntegrations]);
}
